module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAQCAYAAAAmlE46AAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAADwSURBVCiRpZOhTgNBFEXPNCMqViAqVlQgN4EfQGOatLKyH8EnYFEISNoEyS+QIDB4bJPWQVKxEkEFSUkOokOyIbSzDVfOvDNz73sz0EJqX31Xx23qf8O36kadAMTGxilwAnR3sC/AOXCv9lAL9dHDtEK9Uz/UgRp33IZaqgu1VisSdJnJVyToVa0AOkABvGV6E4Fn4CyEsPw5rVYHGfD/Ukdq3WkslOpUPcqwPaCMCaqAJ2ANfGXAY2CNWqWcC7XcYzGqwzSFGerqwOE/qEVQL4BrYAlc7bH4CcxDCPOmjYnbB3yTyfdnhrHbr9NvU/8NKDgWNJNLsKgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/db.png
// module id = f5dN
// module chunks = 1